<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          <span>Meus pontos</span>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label>Ano</label>
              <select
                v-model="search.year"
                class="form-control"
              >
                <option
                  v-for="year in years"
                  :key="year"
                  :value="year"
                >
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <label>Mês</label>
              <select
                v-model="search.month"
                class="form-control"
              >
                <option
                  v-for="month in months"
                  :key="month"
                  :value="month"
                >
                  {{ monthNames[month - 1] }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label>Ação</label>
              <button
                class="btn btn-block btn-info"
                @click="searchChecks"
              >
                Buscar
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-4">
            <div class="form-group">
              <label>Visualizar</label>
              <select
                v-model="viewMode"
                class="form-control"
              >
                <option value="month">
                  Mês
                </option>
                <option value="day">
                  Dia
                </option>
              </select>
            </div>
          </div>

          <div
            v-if="viewMode === 'day'"
            class="col-md-4"
          >
            <div class="form-group">
              <label>Dia</label>
              <input
                v-model="search.day"
                type="date"
                class="form-control"
              >
            </div>
          </div>
        </div>
        <button
          v-if="$store.state.user.remote_check > 0"
          id="check-check"
          class="btn btn-success mb-1"
          :disabled="loadinng"
          @click="openCameraAndStart"
        >
          <i
            class="fa fa-camera mr-1"
            aria-hidden="true"
          />
          Marcar Ponto
        </button>

        <div class="month-summary mt-2">
          <div
            class="kpi-clock-card"
            title="Horário atual"
          >
            <div class="kpi-clock__icon">
              <i
                class="fa fa-clock"
                aria-hidden="true"
              /></div>
            <div class="kpi-clock-value">
              {{ currentTime }}
            </div>
            <small class="kpi-clock-date">{{ currentDate }}</small>
          </div>
          <div
            class="kpi-card"
            :title="viewMode === 'day' ? 'Horas trabalhadas no dia' : 'Horas trabalhadas acumuladas no mês'"
          >
            <div class="kpi-card__icon kpi-icon--worked">
              <i
                class="fa fa-calendar"
                aria-hidden="true"
              /></div>
            <small class="kpi-label">{{ kpiPeriodLabel }}</small>
            <div class="kpi-value">
              {{ kpiWorkedFormatted }}
            </div>
          </div>

          <div
            v-if="hasPendingApprovalsInView"
            class="month-summary__notice"
            role="status"
          >
            <i
              class="fas fa-clock"
              aria-hidden="true"
            />
            <span>Há batidas <strong>pendentes de aprovação</strong> do gestor (efetuadas fora do horário da jornada). Até a revisão, o cálculo usa o <strong>horário previsto</strong> da jornada.</span>
          </div>

        </div>

        <div
          v-if="pageLoading"
          class="text-center py-4"
        >
          <div
            class="spinner-border text-primary"
            role="status"
          >
            <span class="sr-only">Carregando...</span>
          </div>
        </div>

        <div v-else>
          <div
            v-if="!hasShiftEntries"
            class="text-center text-muted py-4"
          >
            Nenhum registro encontrado para o período.
          </div>

          <div
            v-else
            class="shift-list"
          >
            <div
              v-for="shift in shiftEntries"
              :key="shift.shiftKey"
              class="shift-card mb-3"
            >
              <div class="shift-card__header">
                <div>
                  <h5 class="mb-0">
                    Turno {{ shift.displayDate }}
                  </h5>
                  <small class="text-muted">{{ shift.rangeText }}</small>
                </div>
                <div class="shift-card__totals">
                  <div class="metric">
                    <span class="metric__label">Total</span>
                    <span class="metric__value">{{ displayTotal(shift.total) }}</span>
                  </div>
                  <div class="metric">
                    <span class="metric__label">Diferença</span>
                    <span
                      class="metric__value"
                      :class="{ 'text-danger': isNegativeDiff(shift.diff) }"
                    >
                      {{ displayDifference(shift.diff) }}
                    </span>
                  </div>
                </div>
              </div>

              <div
                v-if="shift.timeline.length"
                class="shift-card__body"
              >
                <div
                  v-for="item in shift.timeline"
                  :key="item.id"
                  class="timeline-item"
                  :class="{
                    'timeline-item--interval': item.type === 'interval',
                    'timeline-item--punch': item.type === 'punch'
                  }"
                >
                  <div
                    v-if="item.type === 'punch'"
                    class="punch-card"
                    :class="[getClass(item.punch), item.meta.cardClass]"
                  >
                    <div
                      v-if="item.meta.chipLabel"
                      class="punch-card__top"
                    >
                      <span
                        class="punch-chip"
                        :class="item.meta.chipClass"
                      >
                        <i
                          v-if="item.meta.chipIcon"
                          class="fa"
                          :class="item.meta.chipIcon"
                          aria-hidden="true"
                        />
                        {{ item.meta.chipLabel }}
                      </span>
                    </div>
                    <div class="punch-card__main">
                      <div class="punch-card__info">
                        <span class="punch-card__time">{{ displayTime(item.punch) }}</span>
                      </div>
                      <div
                        v-if="canRequestAdjustment(item.punch)"
                        class="punch-card__actions"
                      >
                        <div
                          class="action-menu"
                          :class="{ 'action-menu--open': adjustmentMenuOpen === item.punch.id }"
                        >
                          <button
                            class="btn btn-link btn-sm p-0"
                            type="button"
                            @click.stop="toggleAdjustmentMenu(item.punch.id)"
                          >
                            <i
                              class="fa fa-ellipsis-v"
                              aria-hidden="true"
                            />
                          </button>
                          <div
                            v-if="adjustmentMenuOpen === item.punch.id"
                            class="action-menu__list"
                            @click.stop
                          >
                            <a
                              class="action-menu__item"
                              href="#"
                              @click.prevent="openAdjustmentModal(item.punch)"
                            >Ajustar horário</a>
                            <a
                              v-if="item.punch.check_adjustment_change_id"
                              class="action-menu__item"
                              href="#"
                              @click.prevent="openAdjustmentChangeModal(item.punch)"
                            >Ver ajuste aplicado</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-else-if="item.type === 'interval'"
                    class="timeline-interval"
                  >
                    <span class="timeline-interval__label">{{ item.label }}</span>
                    <div
                      class="timeline-interval__pill"
                      :class="{
                        'timeline-interval__pill--pending': !item.durationText
                      }"
                    >
                      <i
                        class="fa"
                        :class="item.durationText ? 'fa-clock' : 'fa-hourglass-half'"
                        aria-hidden="true"
                      />
                      <span>
                        {{ item.durationText || 'Em andamento' }}
                      </span>
                    </div>
                  </div>

                  <div
                    v-else-if="item.type === 'reminder'"
                    class="timeline-reminder"
                  >
                    <div class="punch-card punch-card--pending">
                      <div class="punch-card__main">
                        <div class="punch-card__info">
                          <span class="punch-card__time text-muted">{{ item.message }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-else
                class="shift-card__empty"
              >
                <span class="text-muted">Nenhum registro encontrado para este turno.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="cameraIsStarted"
      id="modalCameraCenter"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalCameraCenterTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="modalCameraLongTitle"
              class="modal-title"
            >
              Reconhecimento Facial
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- v-easy-camera substitui a tag <video> -->
            <v-easy-camera
              ref="easyCamera"
              v-model="picture"
              :width="640"
              :height="480"
              :fullscreen="true"
              @approve="handlePicture"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="handlePicture"
            >
              Marcar Ponto
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="adjustmentModal.visible"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      :class="{ show: adjustmentModal.visible }"
      style="display: block;"
      aria-modal="true"
      @click.self="closeAdjustmentModal"
    >
      <div
        class="modal-dialog modal-lg"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Ajustar horário
            </h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="closeAdjustmentModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Horário atual</label>
                <input
                  type="text"
                  class="form-control"
                  :value="adjustmentModal.currentTime"
                  disabled
                >
              </div>
              <div class="form-group col-md-3">
                <label><span class="required">*</span> Nova data</label>
                <input
                  v-model="adjustmentModal.newDate"
                  type="date"
                  class="form-control"
                  :class="{'is-invalid': adjustmentModal.showError && !adjustmentModal.newDate}"
                >
              </div>
              <div class="form-group col-md-3">
                <label><span class="required">*</span> Nova hora</label>
                <input
                  v-model="adjustmentModal.newTime"
                  type="time"
                  class="form-control"
                  :class="{'is-invalid': adjustmentModal.showError && !adjustmentModal.newTime}"
                >
              </div>
            </div>
            <div class="form-group">
              <label><span class="required">*</span> Justificativa</label>
              <textarea
                v-model="adjustmentModal.reason"
                class="form-control"
                rows="3"
                :class="{'is-invalid': adjustmentModal.showError && !adjustmentModal.reason}"
              />
            </div>
            <div
              v-if="isAdmin === 1 || isAdmin === 2"
              class="form-group"
            >
              <div class="form-check">
                <input
                  id="applyNow"
                  v-model="adjustmentModal.applyNow"
                  class="form-check-input"
                  type="checkbox"
                >
                <label
                  class="form-check-label"
                  for="applyNow"
                >Aprovar e aplicar agora</label>
              </div>
            </div>
            <div class="form-group mb-0">
              <p><span class="required">*</span> Campos obrigatórios</p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeAdjustmentModal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="adjustmentModal.saving"
              @click="submitAdjustment"
            >
              {{ adjustmentModal.saving ? 'Salvando...' : 'Confirmar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="adjustmentModal.visible"
      class="modal-backdrop fade show"
      @click="closeAdjustmentModal"
    />

    <div
      v-if="adjustmentChangeModal.visible"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      :class="{ show: adjustmentChangeModal.visible }"
      style="display: block;"
      aria-modal="true"
      @click.self="closeAdjustmentChangeModal"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Ajuste aplicado
            </h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="closeAdjustmentChangeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              v-if="adjustmentChangeModal.loading"
              class="text-center py-3"
            >
              <div
                class="spinner-border text-primary"
                role="status"
              >
                <span class="sr-only">Carregando...</span>
              </div>
            </div>
            <div
              v-else-if="adjustmentChangeModal.error"
              class="alert alert-danger"
              role="alert"
            >
              {{ adjustmentChangeModal.error }}
            </div>
            <div
              v-else-if="adjustmentChangeModal.change"
              class="adjustment-detail"
            >
              <p><strong>Horário antigo:</strong> {{ formatChangeDate(changeOldCreated(adjustmentChangeModal.change)) }}</p>
              <p><strong>Horário aplicado:</strong> {{ formatChangeDate(changeNewCreated(adjustmentChangeModal.change)) }}</p>
              <p><strong>Solicitado por:</strong> {{ requesterName(adjustmentChangeModal.request, adjustmentChangeModal.change) }}</p>
              <p><strong>Aprovado por:</strong> {{ approverName(adjustmentChangeModal.request, adjustmentChangeModal.change) }}</p>
              <p><strong>Aplicado em:</strong> {{ formatChangeDate(changeAppliedAt(adjustmentChangeModal.change)) }}</p>
            </div>
            <div
              v-else
              class="text-muted"
            >
              Nenhum dado de ajuste encontrado.
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeAdjustmentChangeModal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="adjustmentChangeModal.visible"
      class="modal-backdrop fade show"
      @click="closeAdjustmentChangeModal"
    />
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import swal from 'sweetalert'
import EasyCamera from 'easy-vue-camera'

export default {
  components: {
    'v-easy-camera': EasyCamera,
  },
  data() {
    const now = moment()

    return {
      search: {
        year: parseInt(now.year(), 10),
        month: parseInt(now.month(), 10) + 1,
        day: moment().format('YYYY-MM-DD'),
      },
      viewMode: 'day',
      _searchTimer: null,
      _searchDebounceMs: 350,
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      checks: [],
      checksTimelineMap: {},
      bankOfHours: '',
      kpis: {},
      currentDate: moment().format('dddd, D [de] MMMM [de] YYYY'),
      wku: { hours: 8 },
      pageLoading: false,
      loadinng: false,
      cameraIsStarted: false,
      picture: null,
      currentTime: moment().format('HH:mm:ss'),
      isCapturing: false,
      movementDetected: false,
      location: null,
      error: null,
      adjustmentModal: {
        visible: false,
        checkId: null,
        currentTime: '',
        newDate: '',
        newTime: '',
        reason: '',
        applyNow: false,
        saving: false,
        showError: false,
      },
      adjustmentMenuOpen: null,
      adjustmentChangeModal: {
        visible: false,
        loading: false,
        error: null,
        change: null,
        request: null,
        loadingRequest: false,
      },
      userNameCache: {},
    }
  },
  computed: {
    years() {
      const currentYear = moment().year()
      const firstYear = 2019
      const availableYears = []

      for (let year = currentYear; year >= firstYear; year -= 1) {
        availableYears.push(year)
      }

      return availableYears
    },
    monthWorkedMs() {
      const source = this.checks || {}
      let total = 0
      Object.keys(source).forEach(k => {
        const group = source[k]
        if (!group) return
        // Lê do __meta que o backend já popula com total_worked_ms ajustado
        const meta = group.__meta || {}
        const ms = meta.total_worked_ms ?? meta.total_ms ?? null
        const n = typeof ms === 'number' ? ms : parseInt(ms, 10)
        if (!Number.isNaN(n) && n > 0) total += n
      })
      return total
    },
    monthWorkedFormatted() {
      return this.formatMsToHoursString(this.monthWorkedMs)
    },
    kpiWorkedFormatted() {
      if (this.viewMode === 'day') {
        return this.kpis?.day?.workedFormatted || this.monthWorkedFormatted
      }
      return this.kpis?.month?.workedFormatted || this.monthWorkedFormatted
    },
    kpiExpectedFormatted() {
      return this.kpis?.month?.expectedFormatted || null
    },
    kpiDiffFormatted() {
      return this.kpis?.month?.diffFormatted || null
    },
    kpiDiffMs() {
      return typeof this.kpis?.month?.diffMs === 'number' ? this.kpis.month.diffMs : 0
    },
    bankOfHoursDisplay() {
      return this.bankOfHours || '-'
    },
    kpiPeriodLabel() {
      return this.viewMode === 'day' ? 'Dia (acumulado)' : 'Mês (acumulado)'
    },
    hasPendingApprovalsInView() {
      return Array.isArray(this.shiftEntries)
        && this.shiftEntries.some(shift => shift && shift.hasPendingApproval)
    },
    months() {
      return Array.from({ length: 12 }, (_, i) => i + 1)
    },
    isAdmin() {
      const v = localStorage.getItem('is_admin')
      return parseInt(v, 10) || 0
    },

    shiftEntries() {
      const entries = []
      const source = this.checks || {}
      const keys = Object.keys(source || {}).sort((a, b) => {
        try {
          const ma = moment(a)
          const mb = moment(b)
          if (ma.isValid() && mb.isValid()) return mb.valueOf() - ma.valueOf()
        } catch (e) {}
        return 0
      })

      keys.forEach(key => {
        const group = source[key]
        if (!group) return

        const punches = this.extractPunches(group)
        const serverTimeline = this.checksTimelineMap && this.checksTimelineMap[key]
        let timeline = []

        if (Array.isArray(serverTimeline) && serverTimeline.length) {
          timeline = serverTimeline
            .map(it => {
              if (it.type === 'punch') {
                const punchObj = {
                  id: it.id || null,
                  created_at: it.created_at || null,
                  manual: it.meta && it.meta.manual ? 1 : 0,
                  vacation: it.meta && it.meta.vacation ? 1 : 0,
                  solicitation: it.meta && it.meta.solicitation ? 1 : 0,
                  check_request_id: it.meta && it.meta.check_request_id ? it.meta.check_request_id : null,
                  check_request_status_id: it.meta && it.meta.check_request_status_id ? it.meta.check_request_status_id : null,
                  check_request_approver_id: it.meta && it.meta.check_request_approver_id ? it.meta.check_request_approver_id : null,
                  remote: it.meta && it.meta.remote ? 1 : 0,
                  check_adjustment_change_id: it.meta && it.meta.check_adjustment_change_id ? it.meta.check_adjustment_change_id : null,
                  has_schedule_deviation: it.meta && it.meta.has_schedule_deviation ? 1 : 0,
                }

                const displayMeta = it.meta && (it.meta.label || it.meta.icon || it.meta.chipLabel)
                  ? {
                    label: it.meta.label || '',
                    icon: it.meta.icon || 'fa-clock-o',
                    chipLabel: it.meta.chipLabel || '',
                    chipClass: it.meta.chipClass || '',
                    chipIcon: it.meta.chipIcon || '',
                    cardClass: it.meta.cardClass || '',
                  }
                  : this.getPunchMeta(punchObj)

                return { type: 'punch', punch: punchObj, meta: displayMeta }
              }

              if (it.type === 'interval') {
                return {
                  type: 'interval',
                  id: it.id || `${key}-int`,
                  label: it.label || 'Intervalo',
                  durationText: it.duration_text || it.durationText || '',
                  start: it.start_at ? { created_at: it.start_at } : it.start || null,
                  end: it.end_at ? { created_at: it.end_at } : it.end || null,
                }
              }

              if (it.type === 'reminder') {
                return {
                  type: 'reminder',
                  id: it.id || `${key}-rem`,
                  message: it.message || 'Seu par está incompleto, lembre-se de marcar seu ponto de saída',
                }
              }

              return null
            })
            .filter(Boolean)

          if (timeline.length > 1) {
            const getItemTimestamp = item => {
              if (!item) return Number.MAX_SAFE_INTEGER
              if (item.type === 'punch') {
                const ts = moment(item.punch && item.punch.created_at)
                return ts.isValid() ? ts.valueOf() : Number.MAX_SAFE_INTEGER
              }
              if (item.type === 'interval') {
                const ref = item.start && item.start.created_at ? item.start : item.end || null
                const ts = moment(ref && ref.created_at)
                return ts.isValid() ? ts.valueOf() : Number.MAX_SAFE_INTEGER
              }
              return Number.MAX_SAFE_INTEGER
            }

            timeline = timeline.slice().sort((a, b) => getItemTimestamp(a) - getItemTimestamp(b))
          }
        } else {
          timeline = this.buildTimeline(group, key, punches)
        }

        // ── Leitura de total e diff ──────────────────────────────────────────────
        let total = '-'
        let diff = '-'

        // Suporta tanto group.__meta (legado) quanto group.meta (novo backend)
        const meta = (group && group.__meta)
          ? group.__meta
          : (group && group.meta)
            ? group.meta
            : {}

        // Lê total trabalhado — suporta chave com e sem underscore
        const metaTotal = meta.total_worked_formatted
          || meta.totalworkedformatted
          || meta.total_formatted
          || meta.totalformatted
          || null

        // Lê diff — suporta chave com e sem underscore
        const metaDiff = meta.diff_formatted
          || meta.diffformatted
          || null

        if (metaTotal) total = metaTotal
        if (metaDiff) diff = metaDiff

        // Fallback para arrays legados com strings de tempo
        if (total === '-' || diff === '-') {
          const collection = Array.isArray(group)
            ? group
            : Object.values(group || {}).filter(v => typeof v !== 'object')

          const timeStrings = collection.filter(
            v => typeof v === 'string' && /^\d{2}:\d{2}:\d{2}$|^-\d{2}:\d{2}:\d{2}$/.test(v),
          )

          if (total === '-' && timeStrings.length >= 2) total = timeStrings[timeStrings.length - 2]
          if (diff === '-' && timeStrings.length >= 1) diff = timeStrings[timeStrings.length - 1]

          // Fallback absoluto pelos índices fixos do array legado
          if (total === '-') total = group[6] || '-'
          if (diff === '-') diff = group[8] || '-'
        }

        // Turno incompleto (batidas ímpares ou sem batidas) → não exibe diff
        if (punches.length === 0 || punches.length % 2 !== 0) {
          diff = '-'
        }

        const hasPendingApproval = punches.some(punch => this.isPendingApproval(punch))
        // ────────────────────────────────────────────────────────────────────────

        const firstPunch = punches.length > 0 ? punches[0] : null
        const lastPunch = punches.length > 0 ? punches[punches.length - 1] : null
        const rangeText = this.formatShiftRange(firstPunch, lastPunch)

        let displayDate = this.formatDate(key)
        if (key.includes('-shift-')) {
          const parts = key.split('-shift-')
          const baseDate = this.formatDate(parts[0])
          const shiftNumber = parts[1]
          displayDate = `${baseDate} - Turno ${shiftNumber}`
        }

        entries.push({
          shiftKey: key,
          displayDate,
          rangeText,
          total,
          diff,
          hasPendingApproval,
          timeline,
        })
      })

      const todayKey = moment().format('YYYY-MM-DD')
      const currentYear = moment().year()
      const currentMonth = moment().month()
      if (
        this.viewMode === 'month'
        && this.search.year === currentYear
        && this.search.month === currentMonth
        && !entries.find(e => e.shiftKey === todayKey)
      ) {
        entries.unshift({
          shiftKey: todayKey,
          displayDate: this.formatDate(todayKey),
          rangeText: 'Sem registros',
          total: '-',
          diff: '-',
          hasPendingApproval: false,
          timeline: [],
        })
      }

      return entries
    },

    hasShiftEntries() {
      return Array.isArray(this.shiftEntries) && this.shiftEntries.length > 0
    },
  },
  watch: {
    viewMode() {
      this.scheduleSearch()
    },
    'search.year': function () {
      this.viewMode = 'month'
      this.scheduleSearch()
    },
    'search.month': function () {
      this.viewMode = 'month'
      this.scheduleSearch()
    },
    'search.day': function () {
      if (this.viewMode === 'day') this.scheduleSearch()
    },
  },
  mounted() {
    this.searchChecks()
    this.getLocation()
    this.cameraIsStarted = true
    this.startClock()
    document.addEventListener('click', this.handleDocumentClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick)
    this.stopClock()
  },
  methods: {
    extractPunches(group) {
      if (!group) return []

      const collection = Array.isArray(group) ? group : Object.values(group)
      const punches = collection.filter(
        item => item && typeof item === 'object' && item.created_at && typeof item.created_at === 'string',
      )

      const checkRequestIds = new Set(
        punches
          .filter(p => p.id && p.check_request_id)
          .map(p => p.check_request_id),
      )

      const filtered = punches.filter(p => {
        if (!p.id && p.solicitation && p.check_request_id && checkRequestIds.has(p.check_request_id)) {
          return false
        }
        return true
      })

      return filtered.slice(0, 6)
    },
    formatMsToHoursString(ms) {
      if (!ms || typeof ms !== 'number') return '-'

      const totalSeconds = Math.floor(ms / 1000)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60
      const pad = v => v.toString().padStart(2, '0')

      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    },
    buildTimeline(group, shiftKey, punches = null) {
      const items = punches || this.extractPunches(group)
      const timeline = []

      const orderedItems = (items || [])
        .filter(item => item && item.created_at)
        .sort((a, b) => {
          const aMoment = moment(a.created_at)
          const bMoment = moment(b.created_at)
          if (aMoment.isValid() && bMoment.isValid()) {
            return aMoment.valueOf() - bMoment.valueOf()
          }
          return 0
        })

      let intervalIndex = 1

      orderedItems.forEach((punch, index) => {
        timeline.push({
          id: `${shiftKey}-p-${punch.id || index + 1}`,
          type: 'punch',
          punch,
          meta: this.getPunchMeta(punch),
        })

        const isEndOfPair = index % 2 === 1
        const nextPunch = orderedItems[index + 1]

        if (isEndOfPair && nextPunch && nextPunch.created_at) {
          timeline.push({
            id: `${shiftKey}-int-${intervalIndex}`,
            type: 'interval',
            label: `Intervalo ${intervalIndex}`,
            start: punch,
            end: nextPunch,
            durationText: this.formatIntervalDuration(punch, nextPunch),
          })
          intervalIndex += 1
        }
      })

      return timeline
    },
    isPendingApproval(punch) {
      return punch && Number(punch.has_schedule_deviation) === 1
    },
    getPunchMeta(punch) {
      if (!punch) {
        return {
          icon: 'fa-clock-o',
          chipLabel: '',
          chipClass: '',
          chipIcon: '',
          cardClass: '',
        }
      }

      if (this.isPendingApproval(punch)) {
        return {
          icon: 'fa-clock',
          chipLabel: 'Pendente de aprovação',
          chipClass: 'punch-chip--pending-approval',
          chipIcon: 'fa-clock',
          cardClass: 'punch-card--pending-approval',
        }
      }

      if (punch.check_adjustment_change_id) {
        return {
          icon: 'fa-exchange',
          chipLabel: 'Ajuste Aplicado',
          chipClass: 'punch-chip--adjusted',
          chipIcon: 'fa-retweet',
          cardClass: 'punch-card--adjusted',
        }
      }

      if (punch.check_adjustment_request_id) {
        const statusId = punch.check_adjustment_status
        const isApproved = statusId === 2
        const isRejected = statusId === 3

        if (isRejected) {
          return {
            icon: 'fa-times-circle',
            chipLabel: 'Ajuste Rejeitado',
            chipClass: 'punch-chip--request-rejected',
            chipIcon: 'fa-times',
            cardClass: 'punch-card--request-rejected',
          }
        }

        return isApproved ? {
          icon: 'fa-check-circle',
          chipLabel: 'Ajuste Aprovado',
          chipClass: 'punch-chip--request-approved',
          chipIcon: 'fa-check',
          cardClass: 'punch-card--request-approved',
        } : {
          icon: 'fa-clock-o',
          chipLabel: 'Ajuste Pendente',
          chipClass: 'punch-chip--request-pending',
          chipIcon: 'fa-hourglass-half',
          cardClass: 'punch-card--request-pending',
        }
      }

      if (punch.vacation === 1) {
        return {
          icon: 'fa-umbrella',
          chipLabel: 'Férias',
          chipClass: 'punch-chip--vacation',
          chipIcon: '',
          cardClass: 'punch-card--vacation',
        }
      }

      if (punch.manual) {
        return {
          icon: 'fa-edit',
          chipLabel: 'Manual',
          chipClass: 'punch-chip--manual',
          chipIcon: '',
          cardClass: 'punch-card--manual',
        }
      }

      if (punch.check_request_id) {
        const statusId = punch.check_request_status_id
        const isApproved = statusId === 2
        const isRejected = statusId === 3

        if (isRejected) {
          return {
            icon: 'fa-times-circle',
            chipLabel: 'Solicitação Rejeitada',
            chipClass: 'punch-chip--request-rejected',
            chipIcon: 'fa-times',
            cardClass: 'punch-card--request-rejected',
          }
        }

        return isApproved ? {
          icon: 'fa-check-circle',
          chipLabel: 'Solicitação Aprovada',
          chipClass: 'punch-chip--request-approved',
          chipIcon: 'fa-check',
          cardClass: 'punch-card--request-approved',
        } : {
          icon: 'fa-clock-o',
          chipLabel: 'Solicitação Pendente',
          chipClass: 'punch-chip--request-pending',
          chipIcon: 'fa-hourglass-half',
          cardClass: 'punch-card--request-pending',
        }
      }

      if (punch.solicitation) {
        const statusId = punch.check_request_status_id
        const isApproved = statusId === 2
        const isRejected = statusId === 3

        if (isRejected) {
          return {
            icon: 'fa-times-circle',
            chipLabel: 'Solicitação Rejeitada',
            chipClass: 'punch-chip--request-rejected',
            chipIcon: 'fa-times',
            cardClass: 'punch-card--request-rejected',
          }
        }

        return isApproved ? {
          icon: 'fa-check-circle',
          chipLabel: 'Solicitação Aprovada',
          chipClass: 'punch-chip--request-approved',
          chipIcon: 'fa-check',
          cardClass: 'punch-card--request-approved',
        } : {
          icon: 'fa-clock-o',
          chipLabel: 'Solicitação Pendente',
          chipClass: 'punch-chip--request-pending',
          chipIcon: 'fa-hourglass-half',
          cardClass: 'punch-card--request-pending',
        }
      }

      return {
        icon: 'fa-clock-o',
        chipLabel: '',
        chipClass: '',
        chipIcon: '',
        cardClass: '',
      }
    },
    formatShiftRange(firstPunch, lastPunch) {
      if (!firstPunch) return 'Sem registros'

      const startMoment = moment(firstPunch.created_at)
      if (!startMoment.isValid()) return 'Sem registros'

      if (!lastPunch || !lastPunch.created_at) {
        return `Iniciado às ${startMoment.format('HH:mm')}`
      }

      const endMoment = moment(lastPunch.created_at)
      if (!endMoment.isValid() || endMoment.isSame(startMoment)) {
        return `Iniciado às ${startMoment.format('HH:mm')}`
      }

      return startMoment.isSame(endMoment, 'day')
        ? `${startMoment.format('HH:mm')} - ${endMoment.format('HH:mm')}`
        : `${startMoment.format('DD/MM HH:mm')} ${endMoment.format('DD/MM HH:mm')}`
    },
    formatIntervalDuration(start, end) {
      if (!start || !end) return ''

      const startMoment = moment(start.created_at)
      const endMoment = moment(end.created_at)
      if (!startMoment.isValid() || !endMoment.isValid()) return ''

      const diffMs = endMoment.diff(startMoment)
      if (diffMs <= 0) return ''

      const totalMinutes = Math.floor(diffMs / 60000)
      const hours = Math.floor(totalMinutes / 60)
      const minutes = totalMinutes % 60
      const pad = value => value.toString().padStart(2, '0')

      if (hours > 0) {
        const hourLabel = hours === 1 ? 'hora' : 'horas'
        return `${pad(hours)}:${pad(minutes)} ${hourLabel} de intervalo`
      }

      const minuteLabel = minutes === 1 ? 'minuto' : 'minutos'
      return `${pad(minutes)} ${minuteLabel} de intervalo`
    },
    openCameraAndStart() {
      this.cameraOpen()
      this.startCamera()
    },
    canRequestAdjustment(punch) {
      if (!punch || !punch.id) return false
      return this.isAdmin !== 3
    },
    openAdjustmentModal(punch) {
      if (!punch || !punch.id) return
      this.adjustmentMenuOpen = null
      const m = moment(punch.created_at)
      this.adjustmentModal.visible = true
      this.adjustmentModal.checkId = punch.id
      this.adjustmentModal.currentTime = m.isValid() ? m.format('DD/MM/YYYY HH:mm') : ''
      this.adjustmentModal.newDate = m.isValid() ? m.format('YYYY-MM-DD') : ''
      this.adjustmentModal.newTime = m.isValid() ? m.format('HH:mm') : ''
      this.adjustmentModal.reason = ''
      this.adjustmentModal.applyNow = this.isAdmin === 1 || this.isAdmin === 2
      this.adjustmentModal.showError = false
    },
    closeAdjustmentModal() {
      this.adjustmentModal.visible = false
      this.adjustmentModal.saving = false
      this.adjustmentModal.showError = false
    },
    toggleAdjustmentMenu(id) {
      this.adjustmentMenuOpen = this.adjustmentMenuOpen === id ? null : id
    },
    closeAdjustmentChangeModal() {
      this.adjustmentChangeModal.visible = false
      this.adjustmentChangeModal.loading = false
      this.adjustmentChangeModal.error = null
      this.adjustmentChangeModal.change = null
    },
    async openAdjustmentChangeModal(punch) {
      if (!punch || !punch.check_adjustment_change_id) return
      this.adjustmentMenuOpen = null
      this.adjustmentChangeModal.visible = true
      this.adjustmentChangeModal.loading = true
      this.adjustmentChangeModal.error = null
      this.adjustmentChangeModal.change = null
      this.adjustmentChangeModal.request = null

      const id = punch.check_adjustment_change_id
      const api = `${this.$store.state.api}check-adjustment-changes/${id}`

      try {
        const res = await axios.get(api)
        const change = this.normalizeChangePayload(res && res.data)
        this.adjustmentChangeModal.change = change

        const request = await this.loadAdjustmentRequest(change)
        this.adjustmentChangeModal.request = request || (change && change.request) || null

        this.primeUserCache(change, this.adjustmentChangeModal.request)
        await this.resolveUserNames(this.collectUserIds(change, this.adjustmentChangeModal.request))
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message) || error.message || 'Erro ao carregar ajuste'
        this.adjustmentChangeModal.error = msg
      } finally {
        this.adjustmentChangeModal.loading = false
        this.adjustmentChangeModal.loadingRequest = false
      }
    },
    async loadAdjustmentRequest(change) {
      if (!change || !change.request_id) return null
      this.adjustmentChangeModal.loadingRequest = true
      try {
        return await this.fetchAdjustmentRequest(change.request_id)
      } finally {
        this.adjustmentChangeModal.loadingRequest = false
      }
    },
    async resolveUserNames(userIds = []) {
      const uniqueIds = Array.from(new Set((userIds || []).filter(Boolean)))
      if (!uniqueIds.length) return

      const tasks = uniqueIds.map(id => this.resolveUserName(id))
      await Promise.all(tasks)
    },
    async resolveUserName(userId) {
      if (!userId || this.userNameCache[userId]) return this.userNameCache[userId]
      const api = `${this.$store.state.api}users/${userId}`
      try {
        const res = await axios.get(api)
        const user = this.normalizeUser(res?.data?.data || res?.data || null)
        const name = user?.name || null
        if (name) this.cacheUserName(userId, name)
        return name
      } catch (e) {
        return null
      }
    },
    async fetchAdjustmentRequest(requestId) {
      if (!requestId) return null
      const api = `${this.$store.state.api}check-adjustment-requests/${requestId}`
      try {
        const res = await axios.get(api)
        return this.normalizeRequestPayload(res?.data || null)
      } catch (error) {
        return null
      }
    },
    normalizeRequestPayload(raw) {
      if (!raw) return null

      if (Array.isArray(raw)) return raw[0] || null

      if (raw.data) {
        if (Array.isArray(raw.data)) return raw.data[0] || null
        if (raw.data.data && Array.isArray(raw.data.data)) return raw.data.data[0] || null
        return raw.data
      }

      return raw
    },
    collectUserIds(change, request) {
      const req = request || (change && change.request) || null
      const ids = []

      if (req) {
        ids.push(req.requested_by || req.requestedBy)
        ids.push(req.approver_id || req.approverId)
      }

      if (change) {
        ids.push(change.applied_by || change.appliedBy)
      }

      return ids.filter(Boolean)
    },
    primeUserCache(change, request) {
      const req = request || (change && change.request) || null

      if (req) {
        this.cacheUserName(req.requested_by || req.requestedBy, req.user_name || (req.user && req.user.name))
        this.cacheUserName(req.approver_id || req.approverId, req.approver_name || (req.approver && req.approver.name))
      }

      if (change) {
        this.cacheUserName(
          change.applied_by || change.appliedBy,
          change.applied_by_name
            || change.appliedByName
            || (change.applied_by && change.applied_by.name)
            || (change.appliedBy && change.appliedBy.name),
        )
      }
    },
    cacheUserName(userId, name) {
      if (!userId || !name) return
      this.$set(this.userNameCache, userId, name)
    },
    nameFromCache(...userIds) {
      return userIds
        .map(id => this.userNameCache[id])
        .find(name => !!name)
          || null
    },
    normalizeUser(raw) {
      if (!raw) return null
      const data = raw.data || raw
      if (Array.isArray(data)) return data[0] || null
      return data
    },
    normalizeChangePayload(raw) {
      if (!raw) return null

      if (Array.isArray(raw)) {
        return raw[0] || null
      }

      if (raw.data) {
        if (Array.isArray(raw.data)) {
          return raw.data[0] || null
        }
        if (raw.data.data && Array.isArray(raw.data.data)) {
          return raw.data.data[0] || null
        }

        if (raw.data.old_created_at || raw.data.oldCreatedAt) {
          return raw.data
        }
      }

      return raw
    },
    requesterName(request, change) {
      const req = request || (change && change.request) || null
      if (!req) return '-'

      const cached = this.nameFromCache(req.requested_by, req.requestedBy)
      if (cached) return cached

      return req.user_name
          || (req.user && req.user.name)
          || (req.requested_by || req.requestedBy)
          || '-'
    },
    approverName(request, change) {
      const req = request || (change && change.request) || null

      if (req && (req.approver_name || (req.approver && req.approver.name))) {
        return req.approver_name || req.approver.name
      }

      const cached = this.nameFromCache(req && req.approver_id, req && req.approverId, change && change.applied_by, change && change.appliedBy)
      if (cached) return cached

      return (change && change.applied_by_name)
          || (change && change.applied_by && change.applied_by.name)
          || (change && change.applied_by)
          || (change && change.appliedByName)
          || (change && change.appliedBy && change.appliedBy.name)
          || (change && change.appliedBy)
          || '-'
    },
    formatChangeDate(value) {
      if (!value) return '-'
      const m = moment(value)
      return m.isValid() ? m.format('DD/MM/YYYY HH:mm:ss') : value
    },
    changeOldCreated(change) {
      if (!change) return null
      return change.old_created_at || change.oldCreatedAt || null
    },
    changeNewCreated(change) {
      if (!change) return null
      return change.new_created_at || change.newCreatedAt || null
    },
    changeAppliedAt(change) {
      if (!change) return null
      return change.applied_at || change.appliedAt || null
    },
    handleDocumentClick() {
      if (this.adjustmentMenuOpen !== null) {
        this.adjustmentMenuOpen = null
      }
    },
    async submitAdjustment() {
      this.adjustmentModal.showError = true
      this.adjustmentModal.saving = true
      const {
        checkId, newDate, newTime, reason,
      } = this.adjustmentModal

      if (!checkId || !newDate || !newTime || !reason) {
        this.$message('Erro', 'Preencha todos os campos obrigatórios', 'error')
        this.adjustmentModal.saving = false
        return
      }

      const requestedDateTime = `${newDate} ${newTime}:00`
      const payload = {
        check_id: checkId,
        requested_created_at: requestedDateTime,
        reason,
      }

      if (this.isAdmin === 1 || this.isAdmin === 2) {
        payload.apply_now = !!this.adjustmentModal.applyNow
      }

      const api = `${this.$store.state.api}check-adjustment-requests`

      try {
        await axios.post(api, payload)
        this.$message('Sucesso', 'Ajuste enviado com sucesso', 'success')
        this.closeAdjustmentModal()
        this.searchChecks()
      } catch (error) {
        const msg = (error.response && error.response.data) ? error.response.data : 'Erro ao enviar ajuste'
        this.$message('Erro', msg, 'error')
      } finally {
        this.adjustmentModal.saving = false
      }
    },
    getClass(item) {
      if (!item) return ''
      if (item.check_adjustment_change_id) return 'text-adjusted'
      if (item.vacation === 1) return 'text-orange'
      if (item.solicitation) return 'text-gray'
      if (item.check_request_id) return 'text-blue'
      if (item.remote) return 'text-green'
      if (item.manual) return 'text-purple'
      return ''
    },
    displayTime(item) {
      if (!item) return '-'
      return item.vacation === 1 ? 'Férias' : this.format(item.created_at)
    },
    displayTotal(item) {
      if (!item) return '-'
      return item
    },
    displayDifference(item) {
      if (!item) return '-'
      return item
    },
    isNegativeDiff(item) {
      if (!item) return false
      return typeof item === 'string'
        ? item.trim().startsWith('-')
        : typeof item === 'number' ? item < 0 : false
    },
    async startCamera() {
      if (this.location == null) {
        swal(
          'Ops!',
          'Você precisa fornecer acesso à localização do dispositivo. Sem o devido acesso, não será possível registrar a marcação.',
          'error',
        )
        return
      }

      try {
        const devices = await navigator.mediaDevices.enumerateDevices()
        const hasCamera = devices.some(device => device.kind === 'videoinput')
        if (!hasCamera) {
          swal(
            'Atenção',
            'Nenhuma câmera foi encontrada. Por favor, conecte ou ative sua câmera nas configurações do navegador.',
            'error',
          )
          return
        }
        await navigator.mediaDevices.getUserMedia({ video: true })
      } catch (e) {
        swal(
          'Atenção',
          'Permissão para acessar a câmera foi negada ou não está disponível. Por favor, permita o acesso nas configurações do navegador.',
          'error',
        )
        return
      }

      this.cameraIsStarted = true
      $('#modalCameraCenter').modal('show')
    },
    cameraOpen() {
      this.cameraIsStarted = true
      if (this.location == null) return

      setTimeout(() => {
        if (this.$refs.easyCamera) {
          this.$refs.easyCamera.snap()
        }
        setTimeout(() => {
          this.handlePicture()
        }, 1000)
      }, 3500)
    },
    handlePicture() {
      if (!this.picture) {
        this.isCapturing = false
        return
      }

      this.isCapturing = true
      this.$loading(true)
      const imageData = this.picture
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const img = new Image()
      img.onload = () => {
        const width = 640
        const height = (img.height / img.width) * width

        canvas.width = width
        canvas.height = height

        ctx.drawImage(img, 0, 0, width, height)

        const compressedImage = canvas.toDataURL('image/jpeg', 0.7)

        this.picture = compressedImage

        this.getLocation()

        setTimeout(() => {
          if (!this.location) {
            this.isCapturing = false
            this.$loading(false)
            $('#modalCameraCenter').modal('hide')
            swal('Ops!', 'Localização não encontrada. Tente novamente.', 'error').then(() => {
              window.location.reload()
            })
            return
          }

          const api = `${this.$store.state.api}checks/remoteCheck`
          axios
            .post(api, {
              picture: compressedImage,
              location: this.location,
            })
            .then(response => {
              if (response.data.status === 'success') {
                this.$message('Sucesso', 'Ponto registrado com sucesso!', 'success')
                this.searchChecks()
                this.cameraIsStarted = false
                this.isCapturing = false
                $('#modalCameraCenter').modal('hide')
                this.$loading(false)

                setTimeout(() => {
                  window.location.reload()
                }, 1000)
                return
              }

              swal('Ops!', response.data.message, 'error').then(() => {
                window.location.reload()
              })
              this.isCapturing = false
              this.$loading(false)
            })
            .catch(error => {
              const errorMessage = (error.response && error.response.data && error.response.data.message) || 'Erro desconhecido'
              swal('Ops!', errorMessage, 'error').then(() => {
                window.location.reload()
              })
              this.isCapturing = false
              this.$loading(false)
              $('#modalCameraCenter').modal('hide')
            })
        }, 1000)
      }

      img.src = imageData
    },
    resetCapture(video) {
      this.movementDetected = false
      this.isCapturing = false
      if (video) video.style.display = 'none'
    },
    getChceckRequest() {
      const api = `${this.$store.state.api}checkrequests`

      axios
        .get(api)
        .then(response => {
          const payload = response.data?.data || response.data || {}
        })
        .catch(error => {
          this.$message('Erro', error.response?.data || error.message, 'error')
        })
    },
    makeCheck() {
      this.loadinng = true
      this.$loading(true)
      const api = `${this.$store.state.api}checks/remoteCheck`

      $('#modalCameraCenter').modal('hide')
      this.cameraIsStarted = false

      axios
        .post(api, { picture: this.picture, location: this.location })
        .then(response => {
          this.picture = null

          this.$message('Sucesso', 'Ponto registrado!', 'success')

          this.cameraIsStarted = true
          this.searchChecks()
          this.loadinng = false
          this.$loading(false)
        })
        .catch(error => {
          swal('Ops!', error.response?.data?.message || error.message, 'error')
          this.loadinng = false
          this.$loading(false)
        })
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            }
            this.error = null
          },
          error => {
            const errorMessages = {
              [error.PERMISSION_DENIED]: 'Usuário negou a solicitação de geolocalização.',
              [error.POSITION_UNAVAILABLE]: 'A localização não está disponível.',
              [error.TIMEOUT]: 'A solicitação de localização expirou.',
            }
            this.error = errorMessages[error.code] || 'Um erro desconhecido ocorreu.'
          },
        )
      } else {
        this.error = 'Geolocalização não é suportada pelo navegador.'
      }
    },
    formatDate(date) {
      const parsed = moment(date)
      return parsed.isValid() ? parsed.format('DD/MM/YYYY') : date
    },
    format(date) {
      const parsed = moment(date)
      return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm:ss') : date
    },

    startClock() {
      if (this._clockInterval) return
      this._clockInterval = setInterval(() => {
        this.currentTime = moment().format('HH:mm:ss')
      }, 1000)
    },

    stopClock() {
      if (!this._clockInterval) return

      clearInterval(this._clockInterval)
      this._clockInterval = null
    },
    searchChecks() {
      this.pageLoading = true

      let { year } = this.search
      const { month } = this.search
      let dayParam = ''
      let apiMonth = month

      if (this.viewMode === 'day' && this.search.day) {
        const d = moment(this.search.day, 'YYYY-MM-DD')
        if (d.isValid()) {
          year = parseInt(d.year(), 10)
          apiMonth = parseInt(d.month(), 10)
          dayParam = `&day=${this.search.day}`
        }
      } else {
        apiMonth = month >= 1 && month <= 12 ? month - 1 : month
      }

      const api = `${this.$store.state.api}checks/myChecks?year=${year}&month=${apiMonth}${dayParam}`

      axios
        .get(api)
        .then(response => {
          const payload = response.data?.data || response.data || {}

          const organized = payload.organizedChecks || {}
          const organizedTimeline = payload.organizedChecksTimeline || {}

          if (this.viewMode === 'day' && this.search.day) {
            const dayKey = this.search.day
            const dayChecks = organized[dayKey] || []
            const dayTimeline = organizedTimeline[dayKey] || []

            this.checks = { [dayKey]: dayChecks }
            this.checksTimelineMap = { [dayKey]: dayTimeline }

            let dayWorkedMs = 0
            if (Array.isArray(dayChecks) || dayChecks) {
              if (dayChecks && dayChecks.__meta && typeof dayChecks.__meta.total_ms === 'number') {
                dayWorkedMs = dayChecks.__meta.total_ms
              } else if (typeof dayChecks[7] === 'number') {
                dayWorkedMs = dayChecks[7]
              }
            }

            this.kpis = payload.kpis || {}
            this.kpis.day = {
              workedMs: dayWorkedMs,
              workedFormatted: this.formatMsToHoursString(dayWorkedMs),
            }
          } else {
            this.checks = organized
            this.checksTimelineMap = organizedTimeline
            this.kpis = payload.kpis || {}
          }

          this.bankOfHours = payload.bankOfHours || ''
          this.wku = payload.worktime?.worktime || payload.worktime || { hours: 8 }
          this.pageLoading = false
        })
        .catch(error => {
          this.$message('Erro', error.response?.data || error.message, 'error')
          this.checks = []
          this.pageLoading = false
        })
    },
    scheduleSearch() {
      if (this._searchTimer) clearTimeout(this._searchTimer)
      this._searchTimer = setTimeout(() => {
        this.searchChecks()
        this._searchTimer = null
      }, this._searchDebounceMs || 300)
    },
  },
}
</script>

<style scoped>
.video-container {
  position: relative;
  width: 640px;
  height: 480px;
  margin: auto;
}

video {
  width: 100%;
  height: auto;
  display: block;
}

.fullscreen-camera video,
.video-wrapper video {
  transform: scaleX(-1) !important;
}

.fullscreen-camera canvas,
.video-wrapper canvas {
  transform: scaleX(-1) !important;
}

.fullscreen-camera .camera-snap {
  transform: scaleX(-1) !important;
}

::v-deep .fullscreen-camera video,
::v-deep .video-wrapper video {
  transform: scaleX(-1) !important;
}

::v-deep .fullscreen-camera canvas,
::v-deep .video-wrapper canvas {
  transform: scaleX(-1) !important;
}

::v-deep .fullscreen-camera .camera-snap {
  transform: scaleX(-1) !important;
}

.shift-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.action-menu {
  position: relative;
}

.action-menu__list {
  position: absolute;
  top: 100%;
  right: 0;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  min-width: 160px;
  z-index: 10;
  padding: 4px 0;
}

.action-menu__item {
  display: block;
  padding: 8px 12px;
  color: #1f2937;
  text-decoration: none;
  font-size: 0.95rem;
}

.action-menu__item:hover {
  background: #f3f4f6;
  color: #111827;
}

.shift-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.shift-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f1f5f9;
}

.shift-card__totals {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.metric {
  display: flex;
  flex-direction: column;
  text-align: right;
}

.metric__label {
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
}

.metric__value {
  font-weight: 600;
  font-size: 0.95rem;
}

.shift-card__body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1.25rem;
}

.timeline-item {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.timeline-item--interval {
  align-items: center;
  text-align: center;
  padding: 0.35rem 0;
}

.timeline-item--punch {
  background: #ffffff;
  border-radius: 10px;
  padding: 0.5rem 0.75rem;
  align-items: stretch;
}

.timeline-interval {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  align-items: center;
  width: 100%;
}

.timeline-interval__label {
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
  font-weight: 600;
}

.timeline-interval__pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  background: #ede9fe;
  color: #5b21b6;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.timeline-interval__pill i {
  font-size: 0.85rem;
}

.timeline-interval__pill--pending {
  background: #f1f5f9;
  color: #64748b;
}

.punch-card {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 160px;
  width: 100%;
  padding: 0.9rem 1.25rem;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfbfe 100%);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.punch-card--manual {
  border-color: #f59e0b;
  background: #fffbeb;
}

.punch-card--request-approved {
  border-color: #22c55e;
  background: #f0fdf4;
}

.punch-card--request-pending {
  border-color: #facc15;
  background: #fefce8;
}

.punch-card--pending-approval {
  border-color: #f6a609;
  background: #fff7e6;
}

.punch-card--request-rejected {
  border-color: #ef4444;
  background: #fef2f2;
}

.punch-card--adjusted {
  border-color: #2563eb;
  background: #eff6ff;
}

.punch-card--vacation {
  border-color: #34d399;
  background: #ecfdf5;
}

.punch-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.18rem 0.6rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  box-shadow: 0 2px 6px rgba(2, 6, 23, 0.04);
}

.punch-chip--manual {
  background: #fcd34d;
  color: #92400e;
}

.punch-chip--request-approved {
  background: #86efac;
  color: #14532d;
}

.punch-chip--request-pending {
  background: #fde68a;
  color: #92400e;
}

.punch-chip--pending-approval {
  background: #fde8b3;
  color: #8a5800;
}

.punch-chip--request-rejected {
  background: #fca5a5;
  color: #7f1d1d;
}

.punch-chip--adjusted {
  background: #bfdbfe;
  color: #1e3a8a;
}

.punch-chip--vacation {
  background: #bbf7d0;
  color: #065f46;
}

.punch-card__type {
  font-size: 0.8rem;
  font-weight: 500;
}

.punch-card__time {
  font-size: 1rem;
  color: #0f172a;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  font-family: inherit;
}

.punch-card__main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.punch-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
}

.punch-card__info {
  flex: 1 1 auto;
}

.punch-card__top {
  display: flex;
  justify-content: flex-start;
  gap: 0.5rem;
}

.punch-card--pending {
  background: #f1f5f9;
  border-style: dashed;
  border-color: #cbd5f5;
}

.shift-card__empty {
  padding: 1rem 1.25rem;
}

.current-time {
  display: inline-block;
  background: #eef2ff;
  color: #1f2937;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
}

.current-time-inline {
  display: inline-block;
  background: #eef2ff;
  color: #1f2937;
  padding: 0.15rem 0.4rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.95rem;
  width: 92px;
  text-align: center;
  font-variant-numeric: tabular-nums;
  font-family: inherit;
}

.month-summary {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;
  width: 100%;
  flex-wrap: wrap;
}

.kpi-card {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 220px;
  padding: 0.6rem 0.9rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  margin-right: 0.75rem;
}

.kpi-label {
  font-size: 0.7rem;
  color: #6b7280;
}

.kpi-clock-card {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 220px;
  padding: 0.6rem 0.9rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  margin-right: 0.75rem;
}

.kpi-clock__icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #fff0f6;
  color: #001fb3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.35rem;
}

.kpi-clock-value {
  font-size: 2.0rem;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  font-family: inherit;
}

.kpi-clock-date {
  font-size: 0.82rem;
  color: #6b7280;
}

.kpi-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.25rem;
}

.kpi-icon--worked {
  background: #fff0f6;
  color: #001fb3;
}

.kpi-icon--expected {
  background: #ecfdf5;
  color: #059669;
}

.kpi-icon--diff {
  background: #eef2ff;
  color: #0f172a;
}

.kpi-icon--bank {
  background: #ecfdf5;
  color: #059669;
}

.kpi-value {
  font-weight: 700;
  font-size: 1.6rem;
  font-variant-numeric: tabular-nums;
  font-family: inherit;
}

.month-summary__notice {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.45rem 0.65rem;
  border-radius: 8px;
  border: 1px solid #f6a609;
  background: #fff8e8;
  color: #8a5800;
  font-size: 0.82rem;
  font-weight: 600;
}

.timeline-reminder {
  width: 100%;
}

.timeline-reminder .punch-card__time {
  color: #6b7280;
  font-weight: 500;
}

@media (max-width: 768px) {
  .metric__value {
    font-size: 0.85rem;
  }

  .timeline-item {
    align-items: flex-start;
  }

  .timeline-item--interval {
    align-items: flex-start;
    text-align: left;
  }

  .timeline-interval {
    align-items: flex-start;
  }

  .punch-card {
    width: 100%;
  }

  .shift-card__totals {
    width: 100%;
    justify-content: space-between;
  }

  /* Mobile-specific adjustments: center chips and time, make KPI cards stack nicely */
  .month-summary {
    justify-content: center;
    gap: 0.75rem;
  }

  .kpi-card,
  .kpi-clock-card {
    box-sizing: border-box;
    min-width: 0;
    flex: 1 1 48%;
    max-width: 48%;
    padding: 0.5rem 0.75rem;
    margin-right: 0;
  }

  .punch-card__top {
    justify-content: center;
  }

  .punch-chip {
    justify-content: center;
    text-align: center;
  }

  .punch-card__main {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .punch-card__time {
    width: 100%;
    text-align: center;
  }
}

/* Very small screens: stack KPI cards full width */
@media (max-width: 480px) {
  .kpi-card,
  .kpi-clock-card {
    flex: 1 1 100%;
    max-width: 100%;
    width: 100%;
    padding: 0.6rem 0.8rem;
  }

  .month-summary {
    padding: 0 0.5rem;
  }
}

.welcome-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  background: rgba(0, 0, 0, 0.5);
  padding: 5px;
  border-radius: 5px;
}

.btn {
  display: block;
  margin-top: 10px;
}

.check-card {
  cursor: pointer;
  transition: transform 0.2s;
}

.check-card:hover {
  transform: scale(1.02);
}

.text-gray {
  color: #6c757d !important;
}

.text-blue {
  color: #007bff !important;
}

.text-green {
  color: #28a745 !important;
}

.text-purple {
  color: #6f42c1 !important;
}

.text-adjusted {
  color: #1d4ed8 !important;
}

.text-orange {
  color: #fd7e14 !important;
}

.text-muted {
  color: #6c757d !important;
}

.card {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  margin-bottom: 1rem;
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1.25rem;
}

.card-title {
  margin-bottom: 0;
  font-size: 1.25rem;
  font-weight: 500;
}

.card-body {
  padding: 1.25rem;
}

.table {
  margin-bottom: 0;
}

.table th,
.table td {
  vertical-align: middle;
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}

.modal-header {
  border-bottom: 1px solid #dee2e6;
}

.modal-title {
  margin-bottom: 0;
  font-size: 1.5rem;
  font-weight: 500;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  border-top: 1px solid #dee2e6;
  padding: 0.75rem 1.5rem;
}

.desktop-table {
  display: none;
}

.mobile-cards {
  display: block;
}

@media (min-width: 771px) {
  .desktop-table {
    display: block;
  }

  .mobile-cards {
    display: none;
  }
}

@media (max-width: 926px) {
  .table-responsive table {
    font-size: 0.92rem;
  }

  .table th,
  .table td {
    padding: 0.45rem 0.6rem;
  }

  .hide-col-926 {
    display: none !important;
  }
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 771px) {
  .table-responsive table {
    font-size: 0.88rem;
  }

  .table th,
  .table td {
    padding: 0.35rem 0.5rem;
  }
}

::v-deep #modalCameraCenter a > i.mdi.mdi-circle,
::v-deep #modalCameraCenter i.mdi.mdi-circle,
#modalCameraCenter a > i.mdi.mdi-circle,
#modalCameraCenter i.mdi.mdi-circle {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

::v-deep .control-slot > a > i.mdi.mdi-circle,
::v-deep #modalCameraCenter .control-slot > a > i.mdi.mdi-circle,
::v-deep .control-slot i.mdi.mdi-circle,
::v-deep .camera-stack-controls {
  display: none !important;
  visibility: hidden !important;
  width: 0 !important;
  height: 0 !important;
  opacity: 0 !important;
}
</style>
